import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { ColorChecker } from '../../Helpers/Functions/ColorChecker'

export default function SponsorshipButton({team, page, project}) {
    const [value, setValue] = useState(0)
    const [selectedValue, setSelectedValue] = useState(null)
    const [buttonTextColor, setButtonTextColor] = useState('white')
    const [buttonColor, setButtonColor] = useState(page.button_color)
    const [donationOptions, setDonationOptions] = useState([{id: 'one-time', name: 'One-time'}, {id: 'monthly', name: 'Monthly'}])
    const [donationType, setDonationType] = useState({id: page.target_type, name: page.target_type == 'monthly' ? 'Monthly' : 'One-time'})
    const showExtraDetails = page.use_payments && page.use_stripe && page.pass_processing_fee
    const fixedAmount = page.project_fixed_amount
    let textEnding = donationType.id == 'monthly' ? ' / Month' : ''

    useEffect(() => {
        let result = ColorChecker(buttonColor)
        if (result == true) setButtonTextColor('black')

            if (page.project_sponsorship_type == 'fixed' && page.project_fixed_amount) {
                setValue(page.project_fixed_amount)
            }

            if (page.project_sponsorship_type == 'multiple' && page.project_sponsorship_plans) {
                setValue(page.project_sponsorship_plans[0].value)
                setSelectedValue(page.project_sponsorship_plans[0])
            }
    }, [])

    const visitSponsorPage = () => {
        if ((!value || value < 0) && page.use_payments) {
            Alert.show('error', 'Amount must be at least $2')
            return
        }

        if (project && team) {
            window.location = `/sponsor/${team.id}/${project.id}/${page.id}/signup/new?amount=${value}&donation_type=${donationType.id}`
        }
    }

    const getTotalAmounts = (amount) => {
        if (!amount) return parseFloat(amount)

        if (page.pass_processing_fee && donationType.id == 'monthly') {
            let fee = parseFloat(amount) * 0.034 + 0.30
            let total = parseFloat(fee) + parseFloat(amount)
            return parseFloat(total)
        }

        if (page.pass_processing_fee && donationType.id == 'one-time') {
            let fee = parseFloat(amount) * 0.029 + 0.30
            let total = parseFloat(fee) + parseFloat(amount)
            return parseFloat(total)
        }

        return parseFloat(amount)
    }

    const getFixedAmount = (amount) => {
        if (!amount) return parseFloat(amount)

        let fee = parseFloat(amount) * 0.034 + 0.30

        if (donationType.id == 'one-time') { 
            fee = parseFloat(amount) * 0.029 + 0.30
        }

        return parseFloat(fee)
    }

  return (
    <div>
        <div className={page.use_goal_tracking ? `sponsorship-button-project mt-5` : 'mt-3 sponsorship-button-project-full'}>
            {page.project_sponsorship_type == 'custom' && page.use_payments &&
                <div>
                    <p style={{fontSize: '1rem', marginBottom: '15px'}}><b>Select the amount you would like to donate to this {team.project_title.toLowerCase()}</b></p>
                    {page.target_type == 'monthly' && 
                        <div className='mb-2'>
                            <p style={{display: 'inline'}}><b>Donation Type: </b></p>
                            <div className="input-group mt-2" style={{color: 'black', display: 'inline', width: 'fit-content'}}>
                                <Select
                                    className="select-audience select-width"
                                    classNamePrefix="select-audience"
                                    value={donationType}
                                    onChange={(val) => {setDonationType(val)}}
                                    options={donationOptions}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option.id }
                                />
                            </div>
                        </div>
                    }
                    
                        
                    <div className='mb-2'>
                        <p style={{display: 'inline'}}><b>Donation (USD): </b></p>
                        <input 
                            type='number' 
                            step="1" 
                            className='form-control field-width' 
                            name='new_option' 
                            id='new_option' 
                            placeholder='100' 
                            min='2'
                            value={value} 
                            onChange={(event) => setValue(event.target.value)}
                        />
                    </div>
                    <p>
                        {!showExtraDetails && <><b>Total (USD): </b>${ parseFloat(value).toFixed(2) } {textEnding}</>}
                        {showExtraDetails &&
                            <>
                                <b>Total (USD): </b>${ parseFloat(value).toFixed(2) } {textEnding} + ${ getFixedAmount(value).toFixed(2) } payment 
                                processing fee = <b>${ getTotalAmounts(value).toFixed(2) } {textEnding}</b>
                            </>
                        }
                    </p>
                </div>
            }

            {page.project_sponsorship_type == 'fixed' && page.project_fixed_amount && page.project_fixed_amount > 2 && page.use_payments &&
                <div>
                    <p style={{fontSize: '1rem', marginBottom: '10px'}}><b>Click {page.button_text ? page.button_text : 'Sponsor'} to donate to this {team.project_title.toLowerCase()}</b></p>
                    {page.target_type == 'monthly' && 
                        <div className='mb-2'>
                            <p style={{display: 'inline'}}><b>Donation Type: </b></p>
                            <div className="input-group mt-2" style={{color: 'black', display: 'inline', width: 'fit-content'}}>
                                <Select
                                    className="select-audience select-width"
                                    classNamePrefix="select-audience"
                                    value={donationType}
                                    onChange={(val) => {setDonationType(val)}}
                                    options={donationOptions}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option.id }
                                />
                            </div>
                        </div>
                    }
                    <div className='mb-2'>
                        <p style={{display: 'inline'}}><b>Donation (USD): </b>${parseFloat(fixedAmount).toFixed(2)}</p>
                    </div>
                    <p>
                        {!showExtraDetails && <><b>Total (USD): </b>${ parseFloat(fixedAmount).toFixed(2) } {textEnding}</>}
                        {showExtraDetails &&
                            <>
                                <b>Total (USD): </b>${ parseFloat(fixedAmount).toFixed(2) } {textEnding} + ${ getFixedAmount(fixedAmount).toFixed(2) } payment 
                                processing fee = <b>${ getTotalAmounts(fixedAmount).toFixed(2) } {textEnding}</b>
                            </>
                        }
                    </p>
                </div>
            }

            {page.project_sponsorship_type == 'multiple' && page.project_sponsorship_plans && page.use_payments &&
                <div>
                    <p style={{fontSize: '1rem', marginBottom: '15px'}}><b>Select the amount you would like to donate to this {team.project_title.toLowerCase()}</b></p>
                    {page.target_type == 'monthly' && 
                        <div className='mb-2'>
                            <p style={{display: 'inline'}}><b>Donation Type: </b></p>
                            <div className="input-group mt-2" style={{color: 'black', display: 'inline', width: 'fit-content'}}>
                                <Select
                                    className="select-audience select-width"
                                    classNamePrefix="select-audience"
                                    value={donationType}
                                    onChange={(val) => {setDonationType(val)}}
                                    options={donationOptions}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option.id }
                                />
                            </div>
                        </div>
                    }
                    <div className='mb-2'>
                        <p style={{display: 'inline'}}><b>Donation (USD): </b></p>
                        <div className="input-group mt-2" style={{color: 'black', display: 'inline', width: 'fit-content'}}>
                                <Select
                                className="select-audience select-width"
                                classNamePrefix="select-audience"
                                value={selectedValue}
                                onChange={(val) => {setSelectedValue(val); setValue(val.value)}}
                                options={page.project_sponsorship_plans}
                                getOptionLabel={option => `$${parseFloat(option.value).toFixed(2)} ${textEnding}`}
                                getOptionValue={option => option.id }
                            />
                        </div>
                    </div>
                    <p>
                        {!showExtraDetails && <><b>Total (USD): </b>${ parseFloat(value).toFixed(2) } {textEnding}</>}
                        {showExtraDetails &&
                            <>
                                <b>Total (USD): </b>${ parseFloat(value).toFixed(2) } {textEnding} + ${ getFixedAmount(value).toFixed(2) } payment 
                                processing fee = <b>${ getTotalAmounts(value).toFixed(2) } {textEnding}</b>
                            </>
                        }
                    </p>
                </div>
            }


            <div className='project-page-sponsor-bt'>
                <a 
                    className="btn btn-primary mt-2 w-100"
                    href='#'
                    onClick={visitSponsorPage}
                    style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}
                >
                    {page.button_text && <>{page.button_text}</>}
                    {!page.button_text && <>Sponsor</>}
                </a>
            </div>
        </div>
    </div>
  )
}
